(function () {
  var section = document.querySelector(".video-gallery");
  if (!section) return;

  var track = section.querySelector(".video-gallery__track");
  var items = Array.from(section.querySelectorAll(".video-gallery__item"));
  if (!track || !items.length) return;

  var totalOriginal = items.length;
  var isMobile = window.innerWidth <= 768;
  var isInfinite = totalOriginal > 2 && !isMobile;
  var GAP = 20;

  /* ── Initial centering ── */
  requestAnimationFrame(function () {
    var startItem = isMobile ? items[0] : items[Math.floor(totalOriginal / 2)];
    var trackRect = track.getBoundingClientRect();
    var itemRect = startItem.getBoundingClientRect();
    track.scrollLeft += (itemRect.left + itemRect.width / 2) - (trackRect.left + trackRect.width / 2);
  });

  /* ── Rebalance: move real DOM items to keep centered item in the middle (infinite only) ── */
  function rebalance() {
    if (!isInfinite) return;

    var trackItems = Array.from(track.querySelectorAll(".video-gallery__item"));
    var n = trackItems.length;
    if (n < 3) return;

    var trackRect = track.getBoundingClientRect();
    var trackCenter = trackRect.left + trackRect.width / 2;

    // Find centered item index
    var ci = 0;
    var minD = Infinity;
    for (var i = 0; i < n; i++) {
      var r = trackItems[i].getBoundingClientRect();
      var d = Math.abs(r.left + r.width / 2 - trackCenter);
      if (d < minD) { minD = d; ci = i; }
    }

    var half = Math.floor(n / 2);
    var moved = false;

    // Move items from end to start if centered item is too close to start
    while (ci < half) {
      var last = trackItems[trackItems.length - 1];
      var w = last.offsetWidth + GAP;
      track.insertBefore(last, track.firstElementChild);
      track.scrollLeft += w;
      trackItems.pop();
      trackItems.unshift(last);
      ci++;
      moved = true;
    }

    // Move items from start to end if centered item is too close to end
    while (ci > half) {
      var first = trackItems[0];
      var w = first.offsetWidth + GAP;
      track.appendChild(first);
      track.scrollLeft -= w;
      trackItems.shift();
      trackItems.push(first);
      ci--;
      moved = true;
    }
  }

  /* ── Nav buttons ── */
  var prevBtn = section.querySelector(".video-gallery__nav-btn--prev");
  var nextBtn = section.querySelector(".video-gallery__nav-btn--next");

  /* ── Smooth animated scroll ── */
  var animRaf = null;

  function animateScrollTo(target, duration, callback) {
    if (animRaf) cancelAnimationFrame(animRaf);
    var start = track.scrollLeft;
    var distance = target - start;
    if (Math.abs(distance) < 1) { if (callback) callback(); return; }
    var startTime = null;
    duration = duration || 800;

    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var elapsed = timestamp - startTime;
      var progress = Math.min(elapsed / duration, 1);
      track.scrollLeft = start + distance * easeOutCubic(progress);
      if (progress < 1) {
        animRaf = requestAnimationFrame(step);
      } else {
        animRaf = null;
        if (callback) callback();
      }
    }

    animRaf = requestAnimationFrame(step);
  }

  /* ── Find the item closest to center ── */
  function getCenterInfo() {
    var trackItems = Array.from(track.querySelectorAll(".video-gallery__item"));
    var trackRect = track.getBoundingClientRect();
    var center = trackRect.left + trackRect.width / 2;
    var closest = null;
    var closestDist = Infinity;
    var closestIdx = 0;

    for (var i = 0; i < trackItems.length; i++) {
      var rect = trackItems[i].getBoundingClientRect();
      var itemCenter = rect.left + rect.width / 2;
      var dist = Math.abs(itemCenter - center);
      if (dist < closestDist) {
        closestDist = dist;
        closest = trackItems[i];
        closestIdx = i;
      }
    }
    return { item: closest, index: closestIdx, items: trackItems };
  }

  /* ── Scroll to center a specific item ── */
  function scrollToItem(item, duration, cb) {
    var rect = item.getBoundingClientRect();
    var trackRect = track.getBoundingClientRect();
    var offset = (rect.left + rect.width / 2) - (trackRect.left + trackRect.width / 2);
    animateScrollTo(track.scrollLeft + offset, duration || 600, cb);
  }

  /* ── Snap to nearest item ── */
  function snapToNearest() {
    var info = getCenterInfo();
    if (info.item) {
      scrollToItem(info.item, 400, function () {
        rebalance();
      });
    }
  }

  /* ── Arrow navigation ── */
  if (prevBtn) {
    prevBtn.addEventListener("click", function () {
      stopAnimations();
      if (isInfinite) rebalance(); // ensure items are balanced before navigating
      var info = getCenterInfo();
      var prevIdx = info.index - 1;

      if (isMobile) {
        if (prevIdx < 0) prevIdx = 0;
        scrollToItem(info.items[prevIdx], 500);
      } else {
        if (prevIdx < 0) return;
        scrollToItem(info.items[prevIdx], 700, function () {
          rebalance();
        });
      }
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener("click", function () {
      stopAnimations();
      if (isInfinite) rebalance(); // ensure items are balanced before navigating
      var info = getCenterInfo();
      var nextIdx = info.index + 1;

      if (isMobile) {
        if (nextIdx >= info.items.length) nextIdx = info.items.length - 1;
        scrollToItem(info.items[nextIdx], 500);
      } else {
        if (nextIdx >= info.items.length) return;
        scrollToItem(info.items[nextIdx], 700, function () {
          rebalance();
        });
      }
    });
  }

  /* ── Mouse drag with momentum (desktop) ── */
  var isDragging = false;
  var hasDragged = false;
  var dragStartX = 0;
  var dragScrollStart = 0;
  var velocityX = 0;
  var lastMoveX = 0;
  var lastMoveTime = 0;
  var momentumRaf = null;

  function stopAnimations() {
    if (momentumRaf) { cancelAnimationFrame(momentumRaf); momentumRaf = null; }
    if (animRaf) { cancelAnimationFrame(animRaf); animRaf = null; }
  }

  function startMomentum() {
    var friction = 0.93;
    var minVelocity = 0.3;

    function step() {
      velocityX *= friction;
      if (Math.abs(velocityX) < minVelocity) {
        track.classList.remove("is-dragging");
        snapToNearest();
        return;
      }
      track.scrollLeft -= velocityX;
      momentumRaf = requestAnimationFrame(step);
    }

    if (Math.abs(velocityX) > 1) {
      momentumRaf = requestAnimationFrame(step);
    } else {
      track.classList.remove("is-dragging");
      snapToNearest();
    }
  }

  track.addEventListener("mousedown", function (e) {
    if (e.target.closest(".video-gallery__mute, .video-gallery__nav-btn, iframe")) return;
    stopAnimations();
    isDragging = true;
    hasDragged = false;
    dragStartX = e.clientX;
    lastMoveX = e.clientX;
    lastMoveTime = Date.now();
    dragScrollStart = track.scrollLeft;
    velocityX = 0;
    track.classList.add("is-dragging");
    e.preventDefault();
  });

  document.addEventListener("mousemove", function (e) {
    if (!isDragging) return;
    var x = e.clientX;
    var now = Date.now();
    var dt = now - lastMoveTime;

    if (Math.abs(x - dragStartX) > 5) hasDragged = true;

    if (dt > 0) {
      velocityX = ((x - lastMoveX) / dt) * 10;
    }
    lastMoveX = x;
    lastMoveTime = now;

    track.scrollLeft = dragScrollStart - (x - dragStartX) * 0.7;
  });

  document.addEventListener("mouseup", function () {
    if (!isDragging) return;
    isDragging = false;
    startMomentum();
  });

  /* ── Mobile: native touch scroll + snap ── */
  var scrollTimer = null;
  var isTouchActive = false;

  track.addEventListener("touchstart", function () {
    stopAnimations();
    isTouchActive = true;
  }, { passive: true });

  track.addEventListener("touchend", function () {
    isTouchActive = false;
    if (scrollTimer) clearTimeout(scrollTimer);
    scrollTimer = setTimeout(snapToNearest, 120);
  }, { passive: true });

  track.addEventListener("touchcancel", function () {
    isTouchActive = false;
  }, { passive: true });

  track.addEventListener("scroll", function () {
    if (isDragging || momentumRaf) return;
    if (scrollTimer) clearTimeout(scrollTimer);
    if (!isTouchActive) {
      scrollTimer = setTimeout(snapToNearest, 150);
    }
  }, { passive: true });

  /* ── Block clicks after drag ── */
  track.addEventListener("click", function (e) {
    if (hasDragged) {
      e.stopPropagation();
      e.preventDefault();
      hasDragged = false;
    }
  }, true);

  /* ── IntersectionObserver: lazy-load + autoplay/pause MP4 videos ── */
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target.querySelector("video.video-gallery__video");
        if (!video) return;

        if (entry.isIntersecting) {
          // Lazy-load: switch preload to auto so browser fetches the video
          if (video.preload === "none") {
            video.preload = "auto";
            video.load();
          }
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });
    },
    { root: track, threshold: 0.3 }
  );

  items.forEach(function (item) {
    observer.observe(item);
  });

  /* ── Click delegation ── */
  section.addEventListener("click", function (e) {
    var muteBtn = e.target.closest(".video-gallery__mute");
    if (muteBtn) {
      var video = muteBtn.closest(".video-gallery__card").querySelector("video");
      if (!video) return;
      video.muted = !video.muted;
      muteBtn.classList.toggle("is-muted", video.muted);
      return;
    }

    var overlay = e.target.closest(".video-gallery__yt-overlay");
    if (overlay) {
      var iframe = overlay.closest(".video-gallery__card").querySelector("iframe");
      if (iframe) {
        if (!iframe.src && iframe.dataset.src) {
          iframe.src = iframe.dataset.src;
        }
        try {
          iframe.contentWindow.postMessage(
            '{"event":"command","func":"playVideo","args":""}', "*"
          );
        } catch (err) {}
      }
      overlay.style.display = "none";
      return;
    }

    var videoEl = e.target.closest("video.video-gallery__video");
    if (videoEl) {
      if (videoEl.paused) {
        videoEl.play().catch(function () {});
      } else {
        videoEl.pause();
      }
    }
  });
})();
